<template>
  <li
    v-if="filter.length > 0"
    class="single-filter"
    @mouseover="open = true"
    @mouseleave="open = false"
  >
    <div class="single-filter__title">
      {{ title === "Altitude Range" ? "Altitude" : title }}
      <div
        class="gd-searh__num"
        v-if="this.isSelected > 0 && title !== 'Altitude'"
      >
        <span>{{ this.isSelected }}</span>
      </div>
    </div>

    <transition name="slide-up-fade" mode="out-in">
      <div v-if="open" class="single-filter__list-wrap">
        <ul v-if="title !== 'Altitude'" class="single-filter__list">
          <li v-for="(item, i) in filter" :key="i">
            <a
              v-if="item.selected === '0'"
              :href="item.add"
              class="single-filter__list-item"
            >
              <svg>
                <use xlink:href="#icon-square-light"></use>
              </svg>
              <label>{{ item.name }}({{ item.total }})</label>
            </a>
            <a v-else :href="item.remove" class="single-filter__list-item">
              <svg>
                <use xlink:href="#icon-check-square-light"></use>
              </svg>
              <label>{{ item.name }}({{ item.total }})</label>
            </a>
          </li>
        </ul>
        <div v-else class="single-filter__list single-filter__list--altitude">
          <Slider
            :min="+filter[0].name"
            :step="+10"
            :max="+filter[filter.length - 1].name"
            v-model="slider"
          />
          <div class="mob-filters__list-item-wrap">
            <p class="mob-filters__list-item text-left">
              <label>Altitude: {{ slider[0] }}m </label>
            </p>
            <p class="mob-filters__list-item text-right">
              <label>Altitude: {{ slider[1] }}m </label>
            </p>
            <div @click="applay" class="filters__clear activeClass">Apply</div>
          </div>
        </div>
      </div>
    </transition>
  </li>
</template>

<script>
import filterMixin from "../../mixins/filter";
export default {
  name: "SingleFilter",
  data() {
    return { isSelected: 0 };
  },
  mixins: [filterMixin],
  methods: {
    countSelected() {
      this.isSelected = this.filter.filter(
        (item) => item.selected === "1"
      ).length;
    },
  },
  mounted() {
    this.countSelected();
  },
};
</script>
 